// EditSectionDescription — Section 6 of editRealty.
// Substrate: design/editRealty.html lines 795-832 — `<section id="sec-description">`.
//
// Backend-truth map:
//   * description_public  → PropertyWriteSerializer
//   * description_private → PropertyWriteSerializer
//   * communications      → backend-truth-missing (no field on Property
//                           model). Rendered structurally + disabled.
//
// Per CLAUDE.md "Textarea is permanently plain-text only" — no autosize,
// no markdown, no formatting toolbar. Plain controlled textarea.

function EditSectionDescription({ values, onChange, fieldErrors = {} }) {
  const setField = (key, value) => onChange({ ...values, [key]: value });

  return (
    <section
      id="sec-description"
      className="ap-pane"
      aria-labelledby="ap-pane-desc"
    >
      <header className="ap-pane__head">
        <h2 id="ap-pane-desc">
          <i className="fa-solid fa-pen" aria-hidden="true" />
          Опис
        </h2>
        <p>
          Публічний опис побачать усі (включно з анонімами). Приватні нотатки —
          лише авторизовані рієлтори.
        </p>
      </header>

      <div className="ap-row">
        <div className="ap-field ap-field--wide">
          <label htmlFor="desc-public">
            Публічний опис{" "}
            <i
              className="fa-solid fa-eye visibility-icon"
              title="Видно всім"
              aria-hidden="true"
            />
          </label>
          <textarea
            id="desc-public"
            name="description_public"
            className="form-control"
            rows={6}
            placeholder="Розкажіть про переваги об'єкта, інфраструктуру, особливості…"
            value={values.description_public || ""}
            onChange={(e) => setField("description_public", e.target.value)}
          />
          {fieldErrors.description_public ? (
            <small className="form-hint text-danger">
              {fieldErrors.description_public}
            </small>
          ) : null}
        </div>
      </div>

      <div className="ap-row">
        <div className="ap-field ap-field--wide">
          <label htmlFor="desc-private">
            Приватні нотатки{" "}
            <i
              className="fa-solid fa-lock visibility-icon"
              title="Лише авторизовані рієлтори"
              aria-hidden="true"
            />
          </label>
          <textarea
            id="desc-private"
            name="description_private"
            className="form-control"
            rows={4}
            placeholder="МЛС, поведінка власника, особливості зв'язку — лише для колег-рієлторів."
            value={values.description_private || ""}
            onChange={(e) => setField("description_private", e.target.value)}
          />
          {fieldErrors.description_private ? (
            <small className="form-hint text-danger">
              {fieldErrors.description_private}
            </small>
          ) : null}
        </div>
      </div>

      <div className="ap-row">
        <div className="ap-field ap-field--wide">
          <label htmlFor="desc-comm">Комунікації</label>
          {/* TODO: backend-truth-missing — Property has no
              `communications` field. Slot preserved structurally +
              disabled per R6.1 STEP R6.1.4. */}
          <textarea
            id="desc-comm"
            name="communications"
            className="form-control"
            rows={2}
            placeholder="Світло, газ, вода, інтернет…"
            value=""
            disabled
            aria-disabled="true"
          />
          <small className="form-hint">
            Поле тимчасово недоступне (немає підтримки на бекенді).
          </small>
        </div>
      </div>
    </section>
  );
}

export default EditSectionDescription;
